export default __webpack_public_path__ + "static/media/verify.0236bfe6.svg";